import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const darkGoldenTheme = {
    dark: true,
    colors: {
        background: '#0f0f0f',
        surface: '#1a1a1a',
        primary: '#DBA858', // Rich Gold
        'primary-darken-1': '#B88A44',
        secondary: '#8B7355', // Muted Gold/Brown
        'secondary-darken-1': '#6B5842',
        error: '#CF6679',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        'surface-variant': '#121212',
    },
}

const lightGoldenTheme = {
    dark: false,
    colors: {
        background: '#f0ede8',
        surface: '#ffffff',
        primary: '#B88A44',
        'primary-darken-1': '#8B6830',
        secondary: '#8B7355',
        'secondary-darken-1': '#6B5842',
        error: '#B00020',
        info: '#1976D2',
        success: '#388E3C',
        warning: '#F57C00',
        'surface-variant': '#f5f2ee',
    },
}

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'darkGoldenTheme',
        themes: {
            darkGoldenTheme,
            lightGoldenTheme,
        },
    },
    icons: {
        defaultSet: 'mdi',
    },
})
